import { r as registerInstance, h, H as Host } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { a1 as vUndefOr, S as vOneOf, a as vString } from './validation-02b8d01d.js';
import { t as tuple } from './types-6f6b2fba.js';
import './i18n-939e2dee.js';

const loaderVersions = tuple('circle', 'dots', 'logo');

const dsLoaderCss = "ds-loader{display:-ms-flexbox;display:flex}ds-loader .logo-rhombus-one{animation:colorize 1s infinite ease-in-out;animation-delay:0.1s}ds-loader .logo-rhombus-two{animation:colorize 1s infinite ease-in-out;animation-delay:0.2s}ds-loader .logo-rhombus-three{animation:colorize 1s infinite ease-in-out;animation-delay:0.3s}@keyframes colorize{0%{fill:var(--primary)}100%{fill:var(--purple-800)}}";

const DsLoader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.propError = {};
    this.version = 'circle';
    this.size = '2.5rem';
    this.color = 'currentColor';
  }
  watchVersion() {
    /* istanbul ignore if */
    if (!propCheck(this, 'version', loaderVersions.join(' | '), vUndefOr(vOneOf(loaderVersions))))
      return;
  }
  watchSize() {
    /* istanbul ignore if */
    if (!propCheck(this, 'size', 'string', vUndefOr(vString)))
      return;
  }
  watchColor() {
    /* istanbul ignore if */
    if (!propCheck(this, 'color', 'string', vUndefOr(vString)))
      return;
  }
  connectedCallback() {
    runWatchers(this);
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    return (h(Host, null, this.version === 'circle' && (h("ds-icon", { name: "loader-circle", size: this.size, color: this.color })), this.version === 'dots' && (h("ds-icon", { name: "loader-dots", size: this.size, color: this.color })), this.version === 'logo' && (h("svg", { width: this.size, height: this.size, viewBox: "0 -8 90 88", xmlns: "http://www.w3.org/2000/svg" }, h("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h("g", { "fill-rule": "nonzero" }, h("path", { class: "logo-rhombus-one", d: "M19.8793732,0.740879958 L38.4705682,38.8289303 C38.772455,39.4075466 38.772455,40.0867919 38.4705682,40.6654083 L19.9548449,78.7283013 C19.4768575,79.6842762 18.1183669,79.659119 17.6655367,78.7031441 L0.256731712,40.74088 C-0.0451550807,40.1119491 -0.0451550807,39.3823894 0.256731712,38.7283013 L17.7410084,0.76603719 C18.1686814,-0.139623187 19.4517003,-0.139623187 19.8793732,0.740879958 Z" }), h("path", { class: "logo-rhombus-two", d: "M41.1623921,0.740879958 L59.7535871,38.8289303 C60.0554739,39.4075466 60.0554739,40.0867919 59.7535871,40.6654083 L41.2378638,78.7283013 C40.7598764,79.6842762 39.4013858,79.659119 38.9485556,78.7031441 L31.3259141,62.0742133 L41.5649078,40.5899366 C41.8667946,40.0113202 41.8667946,39.2817605 41.5649078,38.5773579 L31.3007569,17.5207542 L39.0240273,0.740879958 C39.4517003,-0.139623187 40.7347191,-0.139623187 41.1623921,0.740879958 Z" }), h("path", { class: "logo-rhombus-three", d: "M60.9108198,0.740879958 L79.7535871,38.8289303 C80.0554739,39.4075466 80.0554739,40.0867919 79.7535871,40.6654083 L61.2378638,78.7283013 C60.7598764,79.6842762 59.4013858,79.659119 58.9485556,78.7031441 L51.9045305,64.0113202 L63.0491845,40.5899366 C63.3510713,40.0113202 63.3510713,39.2817605 63.0491845,38.5773579 L51.7535871,15.3069177 L58.7976122,0.76603719 C59.2001279,-0.139623187 60.4579896,-0.139623187 60.9108198,0.740879958 Z" })))))));
  }
  static get watchers() { return {
    "version": ["watchVersion"],
    "size": ["watchSize"],
    "color": ["watchColor"]
  }; }
};
DsLoader.style = dsLoaderCss;

export { DsLoader as ds_loader };
